import axios from "axios";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ContentRoute, useSubheader } from "../../../_metronic/layout";
import { SchoolActivateDialog } from "./components/SchoolActivateDialog";
import SchoolDeleteDialog from "./components/SchoolDeleteDialog";
import { useSchoolContext } from "./components/SchoolDataContext";
import { SchoolFilter } from "./components/SchoolFilter";
import SchoolTable from "./components/SchoolTable";
import { Snackbar } from "@material-ui/core";
import moment from "moment";
import { SnackbarWrapper } from "../Snackbar/SnackbarWrapper";

export const SchoolList = () => {
  const [schoolData, setSchoolData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const current_branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );
  const context = useSchoolContext();

  const suhbeader = useSubheader();
  suhbeader.setTitle("School List");

  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState("");
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  const handleClose = () => {
    setSuccessSnackbarMessage("");
    setErrorSnackbarMessage("");
    setShowSnackbar(false);
  };

  useEffect(() => {
    const loadSnackbarSuccess = async () => {
      setShowSnackbar(true);
      setLoading(false);
    };
    successSnackbarMessage && successSnackbarMessage != "" && loadSnackbarSuccess();
  }, [successSnackbarMessage]);

  useEffect(() => {
    const loadSnackbarError = async () => {
      setShowSnackbar(true);
      setLoading(false);
    };
    errorSnackbarMessage && errorSnackbarMessage != "" && loadSnackbarError();
  }, [errorSnackbarMessage]);

  useEffect(() => {
    const fetchSchools = async () => {
      setLoading(true);
      setOrigData(context.schoolData.schools || []);
      setLoading(false);
    }
    current_branch && fetchSchools();
  }, [context.schoolData]);

  useEffect(() => {
    setLoading(true);
    context.setRefetch({
      schools: true,
      actives: true,
    });
    setLoading(false);
  }, [current_branch]);

  //Filter Data based on search
  const filterData = (filters) => {
    if (Array.isArray(origData)) {
      const newData = origData.filter(function(school) {
        var add = true;

        for (let key in filters) {
          if (filters[key] != "") {

            if (key !== "school_name" && key !== "primary_email" && key !== "primary_phone" && school[key] != filters[key]) {
              add = false;
            }

            // school_name Filter - regex match
            if (key === "school_name") {
              if (school.school_name.toLowerCase().search(filters[key].toLowerCase()) == -1) {
                add = false;
              }
            }

            // primary_email Filter - regex match
            if (key === "primary_email") {
              if (school.primary_email && school.primary_email.toLowerCase().search(filters[key].toLowerCase()) == -1) {
                add = false;
              } else if (!school.primary_email && filters[key] !== "") {
                add = false;
              }
            }

            // primary_phone Filter - regex match
            if (key === "primary_phone") {
              if (school.primary_phone && school.primary_phone.toLowerCase().search(filters[key].toLowerCase()) == -1) {
                add = false;
              } else if (!school.primary_phone && filters[key] !== "") {
                add = false;
              }
            }

          }
        }
        return add ? true : false;
      });
      setSchoolData(newData);
    }
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={successSnackbarMessage != "" ? "success" : "error"}
          message={successSnackbarMessage != "" ? successSnackbarMessage : errorSnackbarMessage}
        />
      </Snackbar>
      
      <div className={`card card-custom`}>
        {/* begin::Header */}
        <div className="card-header border-0 py-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              School Filters
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              Branch: {current_branch?.branch_name || "No Branch Selected"}
            </span>
          </h3>
          <div className="card-toolbar">
            <Link
              to="/school-information/add-school"
              className="btn btn-primary font-weight-bolder font-size-sm"
            >
              Add School
            </Link>
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body py-0">
          <SchoolFilter
            filterData={filterData}
            origData={origData}
            loading={context.isLoading}
          />
        </div>
      </div>

      <SchoolTable 
        schools={schoolData} 
        showActions={true} 
        loading={context.isLoading} 
      />

      <ContentRoute path="/school-information/school-list/:id/delete-school">
        {({ history, match }) => (
          <SchoolDeleteDialog
            history={history}
            show={match != null}
            id={match && match.params.id}
            setSuccessMessage={setSuccessSnackbarMessage}
            setErrorMessage={setErrorSnackbarMessage}
            onHide={() => {
              history.push("/school-information/school-list");
            }}
          />
        )}
      </ContentRoute>

      <ContentRoute path="/school-information/school-list/:id/activate-school/:isActive">
        {({ history, match }) => (
          <SchoolActivateDialog
            history={history}
            show={match != null}
            id={match && match.params.id}
            isActive={match && match.params.isActive}
            setSuccessMessage={setSuccessSnackbarMessage}
            setErrorMessage={setErrorSnackbarMessage}
            onHide={() => {
              history.push("/school-information/school-list");
            }}
          />
        )}
      </ContentRoute>
    </div>
  );
};